export const isFedRamp = (): boolean => FEDRAMP === 'true';
